import { TP_AMB } from "src/app/shared/enums/fiscal/tp-amb";

export const environment = {
  envName: 'MekanicWEB',
  production: false,
  pilot: false,
  makena: false,
  dota: false,
  agro: false,
  nautical: false,
  mkgoURL: 'https://api.test.mekanicgo.com.br:10082',
  migrate: {
    URL: 'https://invoice.test.mekanicgo.com.br:10082',
    tpAmb: TP_AMB.HOMOLOGACAO
  },
  DEFAULT_CLIENT_DOCUMENT: "01234567",
  DEFAULT_VEHICLE_PLATE: "MKG0000",
  firebase: {
    apiKey: "AIzaSyDjIYVIve7QMO7Xc9ek9hKYk-L1TOK9svM",
    authDomain: "mekanicgo.firebaseapp.com",
    databaseURL: "https://mekanicgo.firebaseio.com",
    projectId: "mekanicgo",
    storageBucket: "mekanicgo.appspot.com",
    messagingSenderId: "244931581171",
    appId: "1:244931581171:web:4b8e6057a7706f1b"
  },
  fraga: {
    rest: "https://accounts.fraga.com.br/realms/cat_teste/protocol/openid-connect/token",
    graphql: "https://apiv2.catalogofraga.com.br/graphql"
  },
  smartUI: "5BB0D19A-200F-4205-9AEE-D64624EF3AA2"
};
